import {
  FEATURE_CART_AND_PAY_AND_POST_V2,
  FEATURE_KEY_SELLING_POINTS,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';

export const useKeySellingPointsFeature = () => {
  const { cartFeatures } = useShoppingCart();
  const isCartEnabled = useFeatureToggleData(FEATURE_CART_AND_PAY_AND_POST_V2);
  const isKeySellingPointsEnabled = useFeatureToggleData(
    FEATURE_KEY_SELLING_POINTS,
  );

  if (!isCartEnabled) return isKeySellingPointsEnabled;

  const hasKeySellingPointsFeature = cartFeatures?.find(
    (feature) => feature?.type === 'BulletPoints',
  );

  return Boolean(hasKeySellingPointsFeature);
};
